import {Routes} from '@angular/router';
import {NortificationComponent} from '@entities/nortification/nortification.component';
import {JhiResolvePagingParams} from 'ng-jhipster';

export const Nortification: Routes = [
  {
    path: 'notifications',
    component: NortificationComponent,
    resolve: {
      pagingParams: JhiResolvePagingParams,
    },
    data: {
      pageTitle: 'entities.nortification.nortification.Thông báo_title',
    },
  },
];
